import { render, staticRenderFns } from "./Caigoudm.vue?vue&type=template&id=f7a85f76&scoped=true"
import script from "./Caigoudm.vue?vue&type=script&lang=js"
export * from "./Caigoudm.vue?vue&type=script&lang=js"
import style0 from "./Caigoudm.vue?vue&type=style&index=0&id=f7a85f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a85f76",
  null
  
)

export default component.exports